"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var runReducerActions = function runReducerActions(middlewareData) {
  var dispatchValue = middlewareData.dispatchValue,
      modules = middlewareData.storeModules,
      dispatchPayload = middlewareData.dispatchPayload;
  var reducerActions = {};
  modules === null || modules === void 0 ? void 0 : modules.map(function (module) {
    var dispatchMethods = module === null || module === void 0 ? void 0 : module.reducerActions;

    if (dispatchMethods) {
      var dispatchMethodsArray = Object.entries(dispatchMethods);
      dispatchMethodsArray === null || dispatchMethodsArray === void 0 ? void 0 : dispatchMethodsArray.map(function (dispatchMethod) {
        reducerActions = _objectSpread(_objectSpread({}, reducerActions), {}, _defineProperty({}, dispatchMethod[0], function () {
          return dispatchMethod[1](middlewareData);
        }));
      });
    }
  });
  var processedDispatchValue = (dispatchPayload === null || dispatchPayload === void 0 ? void 0 : dispatchPayload.reducerAction) !== undefined ? reducerActions[dispatchPayload === null || dispatchPayload === void 0 ? void 0 : dispatchPayload.reducerAction]() : dispatchPayload[dispatchPayload.type];

  if (processedDispatchValue !== null && processedDispatchValue !== undefined) {
    return processedDispatchValue;
  }

  return dispatchValue;
};

var _default = runReducerActions;
exports["default"] = _default;
module.exports = exports.default;